import store from "@/state/store";

export default [
  {
    path: "/",
    name: "default",
    meta: {
      authRequired: true,
    },
    component: () => import("./views/dashboards/default"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("./views/account/login"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("./views/account/register"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("./views/account/forgot-password"),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/logout",
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        localStorage.removeItem("schoolterm");
        localStorage.removeItem("license");
        const authRequiredOnPreviousRoute = routeFrom.matched.some((route) =>
          route.push("/login"),
        );
        next(
          authRequiredOnPreviousRoute ? { name: "default" } : { ...routeFrom },
        );
      },
    },
  },
  {
    path: "/404",
    name: "404",
    component: require("./views/utility/404").default,
  },
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/newstudent",
    meta: { authRequired: true },
    component: () => import("./views/students/newstudent"),
  },
  {
    path: "/viewstudents",
    name: "viewstudents",
    meta: { authRequired: true },
    component: () => import("./views/students/viewstudents"),
  },
  {
    path: "/viewarchivedstudents",
    name: "viewarchivedstudents",
    meta: { authRequired: true },
    component: () => import("./views/students/deletedstudents"),
  },
  {
    path: "/studentprofile",
    name: "studentprofile",
    meta: { authRequired: true },
    component: () => import("./views/students/studentprofile"),
  },
  {
    path: "/printprofile",
    name: "printprofile",
    meta: { authRequired: true },
    component: () => import("./views/students/printprofile"),
  },
  {
    path: "/viewparents",
    meta: { authRequired: true },
    component: () => import("./views/students/viewparents"),
  },
  {
    path: "/enrollments",
    meta: { authRequired: true },
    component: () => import("./views/students/enrollments"),
  },
  {
    path: "/migrate",
    meta: { authRequired: true },
    component: () => import("./views/students/migrate"),
  },
  {
    path: "/subjects",
    meta: { authRequired: true },
    component: () => import("./views/exams/subjects"),
  },
  {
    path: "/competences",
    meta: { authRequired: true },
    component: () => import("./views/settings/competences"),
  },
  {
    path: "/examsets",
    meta: { authRequired: true },
    component: () => import("./views/exams/examsets"),
  },
  {
    path: "/examsettings",
    meta: { authRequired: true },
    component: () => import("./views/exams/examsettings"),
  },
  {
    path: "/grading",
    meta: { authRequired: true },
    component: () => import("./views/exams/grading"),
  },
  {
    path: "/olevelstaffload",
    meta: { authRequired: true },
    component: () => import("./views/exams/staffloads"),
  },
  {
    path: "/marksentry",
    meta: { authRequired: true },
    component: () => import("./views/exams/marksentry"),
  },
  {
    path: "/eotmarksentry",
    meta: { authRequired: true },
    component: () => import("./views/exams/eotmarksentry"),
  },
  {
    path: "/botmarksentry",
    meta: { authRequired: true },
    component: () => import("./views/exams/botmarksentry"),
  },
  {
    path: "/viewmarks",
    meta: { authRequired: true },
    component: () => import("./views/exams/viewmarks"),
  },
  {
    path: "/reportcards",
    meta: { authRequired: true },
    component: () => import("./views/exams/reportcards"),
  },
  {
    path: "/printreportcards",
    meta: { authRequired: true },
    component: () => import("./views/exams/printreportcards"),
  },
  {
    path: "/feescategories",
    meta: { authRequired: true },
    component: () => import("./views/fees/feescategories"),
  },
  {
    path: "/feesbreakdown",
    meta: { authRequired: true },
    component: () => import("./views/fees/feesbreakdown"),
  },
  {
    path: "/optionalfees",
    meta: { authRequired: true },
    component: () => import("./views/fees/optionalfees"),
  },
  {
    path: "/busaries",
    meta: { authRequired: true },
    component: () => import("./views/fees/busaries"),
  },
  {
    path: "/studentbursaries",
    meta: { authRequired: true },
    component: () => import("./views/fees/studentbursaries"),
  },
  {
    path: "/feesexemptions",
    meta: { authRequired: true },
    component: () => import("./views/fees/feesexemptions"),
  },
  {
    path: "/newfeespayments",
    meta: { authRequired: true },
    component: () => import("./views/fees/newfeespayments"),
  },
  {
    path: "/viewfeespayments",
    meta: { authRequired: true },
    component: () => import("./views/fees/viewfeespayments"),
  },
  {
    path: "/paymentsledger",
    meta: { authRequired: true },
    component: () => import("./views/fees/paymentsledger"),
  },
  {
    path: "/optionalfeespayments",
    meta: { authRequired: true },
    component: () => import("./views/fees/optionalfeespayments"),
  },
  {
    path: "/previousbalances",
    meta: { authRequired: true },
    component: () => import("./views/fees/previousbalances"),
  },
  {
    path: "/printreciept",
    meta: { authRequired: true },
    component: () => import("./views/fees/printreciept"),
  },
  {
    path: "/feesbreakdownreport",
    meta: { authRequired: true },
    component: () => import("./views/reports/feesbreakdownreport"),
  },
  {
    path: "/accountsanalysis",
    meta: { authRequired: true },
    component: () => import("./views/reports/accountsanalysis"),
  },
  {
    path: "/recordexpense",
    meta: { authRequired: true },
    component: () => import("./views/expenses/record"),
  },
  {
    path: "/expenseitems",
    meta: { authRequired: true },
    component: () => import("./views/expenses/items"),
  },
  {
    path: "/expensecategories",
    meta: { authRequired: true },
    component: () => import("./views/expenses/categories"),
  },
  {
    path: "/viewexpenses",
    meta: { authRequired: true },
    component: () => import("./views/expenses/view"),
  },

  {
    path: "/schoolterms",
    meta: { authRequired: true },
    component: () => import("./views/settings/schoolterms"),
  },
  {
    path: "/schoolclasses",
    meta: { authRequired: true },
    component: () => import("./views/settings/classes"),
  },
  {
    path: "/schoolstreams",
    meta: { authRequired: true },
    component: () => import("./views/settings/streams"),
  },
  {
    path: "/schoolhouses",
    meta: { authRequired: true },
    component: () => import("./views/settings/houses"),
  },
  {
    path: "/paymentoptions",
    meta: { authRequired: true },
    component: () => import("./views/settings/paymentoptions"),
  },
  {
    path: "/roles",
    meta: { authRequired: true },
    component: () => import("./views/users/roles"),
  },
  {
    path: "/events",
    meta: { authRequired: true },
    component: () => import("./views/settings/events"),
  },
  {
    path: "/subscriptions",
    meta: { authRequired: true },
    component: () => import("./views/settings/subscribe"),
  },
  {
    path: "/users",
    meta: { authRequired: true },
    component: () => import("./views/users/users"),
  },
  {
    path: "/permissions",
    meta: { authRequired: true },
    component: () => import("./views/users/permissions"),
  },
  {
    path: "/audits",
    meta: { authRequired: true },
    component: () => import("./views/users/audits"),
  },
  {
    path: "/schooldepartments",
    meta: { authRequired: true },
    component: () => import("./views/settings/schooldepartments"),
  },
  {
    path: "/profile",
    meta: { authRequired: true },
    component: () => import("./views/settings/profile"),
  },

  {
    path: "/chat",
    meta: { authRequired: true },
    component: () => import("./views/settings/chat"),
  },

  {
    path: "/comingsoon",
    meta: { authRequired: true },
    component: () => import("./views/dashboards/comingsoon"),
  },
  {
    path: "/smscenter",
    meta: { authRequired: true },
    component: () => import("./views/smscenter/messages"),
  },
  {
    path: "/pages/404",
    name: "Error-404",
    meta: { authRequired: true },
    component: () => import("./views/utility/404"),
  },
  {
    path: "/pages/500",
    name: "Error-500",
    meta: { authRequired: true },
    component: () => import("./views/utility/500"),
  },
  {
    path: "/addvisits",
    meta: { authRequired: true },
    component: () => import("./views/sickbay/addvisits"),
  },
  {
    path: "/viewvisits",
    name: "viewvisits",
    meta: { authRequired: true },
    component: () => import("./views/sickbay/viewvisits"),
  },
  {
    path: "/booksborrowed",
    meta: { authRequired: true },
    component: () => import("./views/library/booksborrowed"),
  },
  {
    path: "/bookstore",
    meta: { authRequired: true },
    component: () => import("./views/library/bookstore"),
  },
  {
    path: "/bookcategories",
    meta: { authRequired: true },
    component: () => import("./views/library/bookcategories"),
  },
  {
    path: "/librarybooks",
    meta: { authRequired: true },
    component: () => import("./views/library/librarybooks"),
  },
  {
    path: "/librarysettings",
    meta: { authRequired: true },
    component: () => import("./views/library/librarysettings"),
  },
  {
    path: "/classperformance",
    meta: { authRequired: true },
    component: () => import("./views/reports/classperformance"),
  },
  {
    path: "/divisionbyclass",
    meta: { authRequired: true },
    component: () => import("./views/reports/divisionbyclass"),
  },
  {
    path: "/divisionbysubject",
    meta: { authRequired: true },
    component: () => import("./views/reports/divisionbysubject"),
  },
  {
    path: "/feessummaries",
    meta: { authRequired: true },
    component: () => import("./views/reports/feessummaries"),
  },
  {
    path: "/feespaymentsledger",
    meta: { authRequired: true },
    component: () => import("./views/reports/feespaymentsledger"),
  },
  {
    path: "/moneytransfers",
    meta: { authRequired: true },
    component: () => import("./views/reports/moneytransfers"),
  },
  {
    path: "/chartsofaccount",
    meta: { authRequired: true },
    component: () => import("./views/reports/chartsofaccount"),
  },
  {
    path: "/incomeandexpenditure",
    meta: { authRequired: true },
    component: () => import("./views/reports/incomeandexpenditure"),
  },
  {
    path: "/balancesheet",
    meta: { authRequired: true },
    component: () => import("./views/reports/balancesheet"),
  },
  {
    path: "/trialbalance",
    meta: { authRequired: true },
    component: () => import("./views/reports/trialbalance"),
  },
  {
    path: "/inventoryunits",
    meta: { authRequired: true },
    component: () => import("./views/inventory/units"),
  },
  {
    path: "/inventoryitems",
    meta: { authRequired: true },
    component: () => import("./views/inventory/items"),
  },
  {
    path: "/add-to-store",
    meta: { authRequired: true },
    component: () => import("./views/store/add"),
  },
  {
    path: "/view-store",
    meta: { authRequired: true },
    component: () => import("./views/store/view"),
  },
  {
    path: "/store-loses",
    meta: { authRequired: true },
    component: () => import("./views/store/loses"),
  },
  {
    path: "/add-order",
    meta: { authRequired: true },
    component: () => import("./views/requisition/add"),
  },
  {
    path: "/view-order",
    meta: { authRequired: true },
    component: () => import("./views/requisition/view"),
  },
  {
    path: "/school-requirement",
    meta: { authRequired: true },
    component: () => import("./views/requirement/category"),
  },
  {
    path: "/requirement-collection",
    meta: { authRequired: true },
    component: () => import("./views/requirement/collection"),
  },
  {
    path: "/requirement-allocation",
    meta: { authRequired: true },
    component: () => import("./views/requirement/allocation"),
  },
  {
    path: "/view-requirement-collection",
    meta: { authRequired: true },
    component: () => import("./views/requirement/view"),
  },
  // {
  //   path: '/setoptionalfees',
  //   meta: { authRequired: true },
  //   component: () => import('./views/fees/setoptionalfees')
  // },
  {
    path: "/staffmembers",
    meta: { authRequired: true },
    component: () => import("./views/hr/staffmembers"),
  },
  {
    path: "/positions",
    meta: { authRequired: true },
    component: () => import("./views/hr/positions"),
  },
  {
    path: "/salarydetails",
    meta: { authRequired: true },
    component: () => import("./views/hr/salarydetails"),
  },
  {
    path: "/allowances",
    meta: { authRequired: true },
    component: () => import("./views/hr/allowances"),
  },
  {
    path: "/staffadvances",
    meta: { authRequired: true },
    component: () => import("./views/hr/staffadvances"),
  },
  {
    path: "/staffleaves",
    meta: { authRequired: true },
    component: () => import("./views/hr/staffleaves"),
  },
  {
    path: "/deductions",
    meta: { authRequired: true },
    component: () => import("./views/hr/deductions"),
  },
  {
    path: "/studentattendance",
    meta: { authRequired: true },
    component: () => import("./views/attendance/studentattendance"),
  },
  {
    path: "/staffattendance",
    meta: { authRequired: true },
    component: () => import("./views/attendance/staffattendance"),
  },
  {
    path: "/studentrollcall",
    meta: { authRequired: true },
    component: () => import("./views/attendance/studentrollcall"),
  },
  {
    path: "/stafftimesheets",
    meta: { authRequired: true },
    component: () => import("./views/attendance/stafftimesheets"),
  },
  {
    path: "/studenttimesheets",
    meta: { authRequired: true },
    component: () => import("./views/attendance/studenttimesheets"),
  },
  {
    path: "/canteens",
    meta: { authRequired: true },
    component: () => import("./views/canteen/canteen"),
  },
  {
    path: "/canteenusers",
    meta: { authRequired: true },
    component: () => import("./views/canteen/canteenuser"),
  },
  {
    path: "/products",
    meta: { authRequired: true },
    component: () => import("./views/canteen/products"),
  },
  {
    path: "/salespoint",
    meta: { authRequired: true },
    component: () => import("./views/canteen/salespoint"),
  },
  {
    path: "/salesinvoice",
    meta: { authRequired: true },
    component: () => import("./views/canteen/salesinvoice"),
  },
  {
    path: "/pocketmoney",
    meta: { authRequired: true },
    component: () => import("./views/pocketmoney/addpocketmoney"),
  },
  {
    path: "/pocketmoneybalances",
    meta: { authRequired: true },
    component: () => import("./views/pocketmoney/pocketmoneybalances"),
  },
  {
    path: "/savings",
    meta: { authRequired: true },
    component: () => import("./views/pocketmoney/addsavings"),
  },
  {
    path: "/savingsbalances",
    meta: { authRequired: true },
    component: () => import("./views/pocketmoney/savingsbalances"),
  },
  {
    path: "/withdraws",
    meta: { authRequired: true },
    component: () => import("./views/pocketmoney/withdraws"),
  },
  {
    path: "/generalcomments",
    meta: { authRequired: true },
    component: () => import("./views/comments/generalcomments"),
  },
  {
    path: "/summarisedreport",
    meta: { authRequired: true },
    component: () => import("./views/exams/final"),
  },
  {
    path: "/printsummarisedreport",
    meta: { authRequired: true },
    component: () => import("./views/exams/printsummarised"),
  },
  {
    path: "/viewonlinepayments",
    meta: { authRequired: true },
    component: () => import("./views/fees/onlinepayments"),
  },
  {
    path: "/combinations",
    meta: { authRequired: true },
    component: () => import("./views/alevel/combinations"),
  },
  {
    path: "/alevelsubjects",
    meta: { authRequired: true },
    component: () => import("./views/alevel/subjects"),
  },
  {
    path: "/papers",
    meta: { authRequired: true },
    component: () => import("./views/alevel/papers"),
  },
  {
    path: "/alevelmarksentry",
    meta: { authRequired: true },
    component: () => import("./views/alevel/marksentry"),
  },
  {
    path: "/viewalevelmarks",
    meta: { authRequired: true },
    component: () => import("./views/alevel/viewmarks"),
  },
  {
    path: "/alevelstaffloads",
    meta: { authRequired: true },
    component: () => import("./views/alevel/staffload"),
  },
  {
    path: "/alevelgeneralcomments",
    meta: { authRequired: true },
    component: () => import("./views/alevel/comments"),
  },
  {
    path: "/alevelreportcards",
    meta: { authRequired: true },
    component: () => import("./views/alevel/reportcard"),
  },
  {
    path: "/printalevelreportcards",
    meta: { authRequired: true },
    component: () => import("./views/alevel/printreport"),
  },
  {
    path: "/viewsubjectmarks",
    meta: { authRequired: true },
    component: () => import("./views/alevel/subjectmarks"),
  },

  {
    path: "/payment",
    name: "payments",
    meta: { authRequired: true },
    component: () => import("./views/account/payments"),
  },
  {
    path: "/license-expired",
    name: "license-expired",
    meta: { authRequired: true },
    component: () => import("./views/account/license-expired"),
  },
  {
    path: "/feesdefaulters",
    name: "fees-defaulters",
    meta: { authRequired: true },
    component: () => import("./views/fees/fees_defaulters"),
  },
  {
    path: "/printfeesdefaulters",
    name: "print-fees-defaulters",
    meta: { authRequired: true },
    component: () => import("./views/fees/print_fees_defaulters"),
  },
  {
    path: "/systemattendance",
    name: "system-attendance",
    meta: { authRequired: true },
    component: () => import("./views/attendance/systemattendance"),
  },
];
